import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="inicio" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <p className="hero-subtitle-top">
            Mentoría Pastoral y Personalizada
          </p>
          <h1 className="hero-title">
            Mentoría con Dr. Moisés Mejía
          </h1>
          <p className="hero-subtitle">
            Un espacio íntimo pastoral donde serás escuchado y recibirás buen consejo,
            exhortación y amor de un Doctor en Misionología con amplia experiencia ministerial.
          </p>
          <div className="hero-buttons">
            <a href="#contacto" className="btn-primary">
              Agendar Consulta
            </a>
            <a href="#recursos" className="btn-secondary">
              Recursos Gratuitos
            </a>
          </div>
        </div>
        <div className="hero-image">
          <img
            src="/img-mentor-pastoral.jpg"
            alt="Mentoría Pastoral"
            className="hero-img"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;